import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=04e1d331&scoped=true&"
import script from "./Signup.vue?vue&type=script&lang=js&"
export * from "./Signup.vue?vue&type=script&lang=js&"
import style0 from "../assets/styleLogin.css?vue&type=style&index=0&id=04e1d331&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1d331",
  null
  
)

export default component.exports